import { useTranslation } from 'react-i18next';
import { Chip, Tooltip } from '@mui/material';
import { AccessTime } from '@mui/icons-material';

import { FareCountdown as Countdown } from '../useFareCountdown';

interface Props {
  countdown: Countdown;
}

/**
 * Lo que le queda de vida a la tarifa, siempre a la vista mientras se carga la
 * reserva. Pasa a rojo antes de vencer para que el asesor decida si termina o
 * vuelve a buscar, en vez de descubrirlo cuando el hold falla.
 */
export function FareCountdown({ countdown }: Props) {
  const { t } = useTranslation();

  if (countdown.status === 'unknown') return null;

  const expired = countdown.status === 'expired';
  // El tooltip nombra el reloj que corta (§21.9: lo que se dibuja dice lo que
  // se valida): el TTL de 15 min es NUESTRO; el vencimiento firmado, del
  // proveedor — atribuirle al proveedor un plazo local (o al revés) es mentir.
  const signedByProvider = countdown.source === 'provider';

  return (
    <Tooltip
      title={
        expired
          ? t(
            signedByProvider
              ? 'travelServices.booking.fareSignedExpiredHint'
              : 'travelServices.booking.fareExpiredHint',
          )
          : t(
            signedByProvider
              ? 'travelServices.booking.fareSignedTtlHint'
              : 'travelServices.booking.fareTtlHint',
          )
      }
    >
      <Chip
        size="small"
        icon={<AccessTime />}
        color={expired ? 'error' : countdown.status === 'expiring' ? 'warning' : 'default'}
        variant={countdown.status === 'fresh' ? 'outlined' : 'filled'}
        label={
          expired
            ? t('travelServices.booking.fareExpired')
            : t('travelServices.booking.fareValidFor', { time: countdown.label })
        }
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      />
    </Tooltip>
  );
}
